export const CONST = {
  TOP_LEFT_TEXT: $localize`Linked Sites`,
  TOP_RIGHT_TEXT: $localize`Group`,
  DESCRIPTIONS: $localize`Please select Location Group to see Linked Sites`,
  EDIT: 'edit',
  ENTER: $localize`Enter`,
  SEARCH_SITES_PLACEHOLDER: $localize`Search Sites`,
  NO_SITES: $localize`No sites assigned`,
};

export const DISPLAYED_COLS = ['code', 'name', 'siteCount', 'action'];
export const TABLE_COLS = ['sites', 'slic'];
